export const GET_CATEGORIES_PROMOTIONS = "GET_CATEGORIES_PROMOTIONS"
export const GET_CATEGORIES_PROMOTIONS_SUCCESS = "GET_CATEGORIES_PROMOTIONS_SUCCESS"

export const GET_CATEGORIES_PROMOTIONS_API_ERROR = "GET_CATEGORIES_PROMOTIONS_API_ERROR"
